import { req } from './axiosFun';

// 查询用户列表
export const listUserinfo=(query)=> {
  return req(
    "post",
    "/api/admin/userinfo/list",
    query
  )
}

// 查询用户详细
export const getUserinfo=(id)=> {
  return req(
    'get',
    '/api/admin/userinfo/',
    id
  )
}




// WEBPACK FOOTER //
// ./src/api/userinfo.js